<div class="table-relative">
  <div class="title-error" *ngIf="clicked && control?.errors">
    <p>{{ getError() }}</p>
  </div>

  <div class="title-error" *ngIf="clicked && !ngModelValue">
    <p>{{name}}</p>
  </div>
</div>
